<div class="main-loading-container">
  <div class="shopify-error">
    <mat-icon>close</mat-icon>
    <h1>Shopify verification failed</h1>
    <p>Please try again later</p>
  </div>
</div>
